export const DEBT_SUMMARY = 'DEBT_SUMMARY';



// WEBPACK FOOTER //
// ./src/constants/debt.js